import { useState } from "react";
import { LoadingOverlay } from "../../common/LoadingOverley/LoadingOverley";
import { FiltersTable } from "../FiltersTable/FiltersTable";
import { TransactionEditCards } from "./TransactionEditCards";
import {
  CardToUploadStatusCardMarketEnum,
  CardToUploadStatusCardTraderEnum,
} from "magic-shared-types";
import { useGetCardToEditByUserIdQuery } from "../../../services/myServer/cardToEdit";
import { useSelector } from "react-redux";
import { selectGame } from "../../../store/slices/global";

export const SectionEditCards = () => {
  const [page, setPage] = useState(1);
  const [statusCt, setStatusCt] = useState<
    CardToUploadStatusCardTraderEnum | undefined
  >(undefined);
  const [statusCm, setStatusCm] = useState<
    CardToUploadStatusCardMarketEnum | undefined
  >(undefined);
  const [name, setName] = useState("");
  const pageSize = 20;
  const game = useSelector(selectGame);

  const { data: cardToUploadData, isLoading: cardToUploadLoading } =
    useGetCardToEditByUserIdQuery({
      page,
      pageSize,
      status_ct: statusCt || undefined,
      status_cm: statusCm || undefined,
      game_id: game.id,
      name,
    });

  if (cardToUploadLoading) {
    return <LoadingOverlay />;
  }
  return (
    <>
      <FiltersTable
        statusCt={statusCt}
        statusCm={statusCm}
        onStatusCtChange={setStatusCt}
        onStatusCmChange={setStatusCm}
        page={page}
        onPageChange={setPage}
        total={cardToUploadData?.pagination.total || 0}
        pageSize={pageSize}
        setName={setName}
      />
      {cardToUploadData && (
        <TransactionEditCards data={cardToUploadData?.data} />
      )}
    </>
  );
};
